import React, { useState } from "react";
import { formatFromJsonDate } from "../../../../dateConfig";
import { Card, CardContent } from "@mui/material";
import Tab from "../../../Tab";
import { MdHistory } from "react-icons/md";
import { RiListSettingsLine } from "react-icons/ri";
import { MdOutlineTimerOff } from "react-icons/md";
import InfoList from "../../../InfoList";
import StatusLabel from "../../../input/StatusLabel";
import { FORMS, MODULES } from "../../../../const";
import JobStatusHistory from "./JobStatusHistory";
import JobStatusManager from "./JobStatusManager";
import JobTimeRemovalLog from "./JobTimeRemovalLog";

const JobStatusManagement = ({
  jobId,
  jobCode,
  requestId,
  requestCode,
  status,
  currentTimeFreeze,
  close,
}) => {
  const [tab, setTab] = useState(1);

  const [reloadData, setReloadData] = useState(true);
  const [currentStatus, setCurrentStatus] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const JobStatusHeader = () => (
    <InfoList
      showHeader={false}
      showSegment={false}
      content={[
        {
          title: "Request",
          value: requestCode,
        },
        {
          title: "Job",
          value: jobCode,
        },
        {
          title: "Current Status",
          value: (
            <StatusLabel
              isLoading={isLoading}
              status={currentStatus ? currentStatus.rstDescription : ""}
              color={currentStatus ? currentStatus.staColor : "grey"}
            />
          ),
        },
        {
          title: "Last Updated",
          value: currentStatus
            ? currentStatus.rstDate
              ? formatFromJsonDate(currentStatus.rstDate)
              : "N/A"
            : "N/A",
        },
      ]}
    />
  );

  return (
    <Card>
      <CardContent
        style={{ height: "80vh", minWidth: "65vw", overflow: "scroll" }}
      >
        <div className="ui top attached tabular menu">
          <Tab
            Icon={MdHistory}
            onClick={() => {
              setTab(1);
            }}
            active={tab === 1}
            label="Status History"
            authenticated={true}
            form={FORMS.JOB_STATUS.HISTORY.form}
            module={MODULES.Transaction}
          />
          <Tab
            Icon={RiListSettingsLine}
            onClick={() => {
              setTab(2);
            }}
            active={tab === 2}
            label="Status Manager"
            authenticated={true}
            form={FORMS.JOB_STATUS.MANAGER.form}
            module={MODULES.Transaction}
          />
          <Tab
            Icon={MdOutlineTimerOff}
            onClick={() => {
              setTab(3);
            }}
            active={tab === 3}
            label="Time Removal Log"
            authenticated={true}
            form={FORMS.JOB_STATUS.HISTORY.form}
            module={MODULES.Transaction}
          />
        </div>
        <div
          className="ui bottom attached active tab segment"
          style={{ display: tab === 1 ? "block" : "none" }}
        >
          <JobStatusHistory
            Header={JobStatusHeader}
            reloadData={reloadData}
            setReloadData={setReloadData}
            isLoading={isLoading}
            setIsLoading={setIsLoading}
            setCurrentStatus={setCurrentStatus}
            jobId={jobId}
            requestId={requestId}
          />
        </div>
        <div
          className="ui bottom attached active tab segment"
          style={{ display: tab === 2 ? "block" : "none" }}
        >
          <JobStatusManager
            Header={JobStatusHeader}
            status={status}
            reloadData={reloadData}
            setReloadData={setReloadData}
            currentStatus={currentStatus}
            isLoading={isLoading}
            setIsLoading={setIsLoading}
            jobId={jobId}
            requestId={requestId}
            close={close}
            currentTimeFreeze={currentTimeFreeze}
          />
        </div>
        <div
          className="ui bottom attached active tab segment"
          style={{ display: tab === 3 ? "block" : "none" }}
        >
          <JobTimeRemovalLog
            Header={JobStatusHeader}
            jobId={jobId}
            active={tab === 3}
          />
        </div>
      </CardContent>
    </Card>
  );
};

export default JobStatusManagement;
